import { Box, Stack, TextField } from "@mui/material";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AutoCompleteList from "components/AutoCompleteList";
import moment from "moment";
import StockHistoryTable from "pages/inventory/history_template/StockHistoryTable";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { dispatch } from "store";
import { getAdminThunk } from "store/reducers/accounts";
import { getAdminStockHistoryThunk } from "store/reducers/inventory/stock/adminStockSlice";

const AdminStockHistory = () => {
  const [searchParams] = useSearchParams();
  const time = searchParams.get("time");
  const admin = searchParams.get("admin");
  const [filter, setFilter] = useState({
    time: time ? moment(time).add(1, "second") : moment(),
    admin: null,
  });

  useEffect(() => {
    dispatch(
      getAdminStockHistoryThunk({
        time: filter.time?.toISOString(),
        admin: filter.admin?.profile?.id ?? "" ,
      })
    );
  }, [filter.admin, filter.time]);
  const state = useSelector((state) => state.adminStock);

  useEffect(() => {
    dispatch(getAdminThunk());
  }, []);
  const admins = useSelector((state) => state.accounts.admins);

  useEffect(() => {
    if (admin && admins) {
      const dist = admins.find((item) => item.id ===  parseInt(admin));
    //   console.log(dist)
      if(dist){
        setFilter((state) => ({ ...state, admin: dist }));
      }
      
    }
  }, [admin, admins]);
  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="center" spacing={1.5} marginY={2}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="Pick a date"
            value={filter.time}
            onChange={(value) => setFilter({ ...filter, time: value })}
            renderInput={(params) => (
              <TextField variant="outlined" fullWidth {...params} />
            )}
          />
        </LocalizationProvider>

        <AutoCompleteList
          items={admins}
          name="username"
          label="Filter admin"
          setValue={(value) => ({ ...filter, admin: filter.admin })}
          value={filter.admin}
        />
      </Stack>
      <StockHistoryTable items={state.history} />
    </Box>
  );
};

export default AdminStockHistory;
